/**
 * 상담 대시보드 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const DemoConsultationDashboardPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="상담 대시보드 (데모)" currentIcon={ChartBarIcon} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">총 상담 건수</h3>
            <p className="text-3xl font-bold text-blue-600 mt-2">124건</p>
            <p className="text-sm text-gray-600 mt-1">이번 달 +12건</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">평균 만족도</h3>
            <p className="text-3xl font-bold text-green-600 mt-2">4.5/5.0</p>
            <p className="text-sm text-gray-600 mt-1">지난 달 대비 +0.3</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium">후속 상담 필요</h3>
            <p className="text-3xl font-bold text-orange-600 mt-2">8건</p>
            <p className="text-sm text-gray-600 mt-1">이번 주 예정</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-bold mb-4">최근 상담 기록</h2>
          <div className="space-y-4">
            <div className="border-l-4 border-blue-500 pl-4">
              <h3 className="font-semibold">김민수 - 학습상담</h3>
              <p className="text-sm text-gray-600">2025-10-25 | 김선생님</p>
            </div>
            <div className="border-l-4 border-green-500 pl-4">
              <h3 className="font-semibold">이영희 - 진로상담</h3>
              <p className="text-sm text-gray-600">2025-10-24 | 박선생님</p>
            </div>
            <div className="border-l-4 border-purple-500 pl-4">
              <h3 className="font-semibold">박지훈 - 학습상담</h3>
              <p className="text-sm text-gray-600">2025-10-23 | 김선생님</p>
            </div>
          </div>
          <div className="mt-6 text-center text-gray-500 text-sm">
            📢 데모 모드에서는 실제 AI 인사이트가 제공되지 않습니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoConsultationDashboardPage;
